export function UpdateBanner({ onReload }: { onReload: () => void }): React.JSX.Element {
  return (
    <div className="banner banner-update" role="status">
      Update ready — reload when you are flat.
      <button type="button" className="btn" onClick={onReload}>
        Reload
      </button>
    </div>
  );
}
